import { render, staticRenderFns } from "./RouteVehicleInfo.vue?vue&type=template&id=4defecbf&"
import script from "./RouteVehicleInfo.vue?vue&type=script&lang=js&"
export * from "./RouteVehicleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports